import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { Image } from '../../common/image'
import { TextEllipsisStaticLine } from '../../common/textEllipsis/TextEllipsisStaticLine'
import chatbotIcon from '../chatbot.svg'
import { selectTopicActive } from '../store/slice'

const HeaderChatbot = ({ toggleChatbot }) => {
  const topicActive = useSelector(selectTopicActive)
  const newChatText = I18n.t('chatbot.NEW_CHAT')

  return (
    <>
      <div className="chatbot-header">
        <div className="chatbot-title">
          <Image
            src={chatbotIcon}
            className="chatbot-img"
            alt="logo"
            style={{ width: 40, height: 40 }}
          />
          <div className="title-content">
            <Element style={{ fontSize: 14 }} className="main-title">
              FiinGate Assistant
            </Element>
            <TextEllipsisStaticLine
              text={topicActive?.topicTitle || newChatText}
              lineClamp={1}
              isI18n={false}
              appendStyle={{ fontSize: 14, color: '#FFFFFF99' }}
            />
          </div>
        </div>
        <Icon
          style={{ color: '#F3F3F3', fontSize: 16, opacity: 0.7 }}
          onClick={toggleChatbot}
          className="icon-delete-circle-fill"
        />
      </div>
    </>
  )
}

export default HeaderChatbot
